import { Box } from '@cmg/design-system';
import React from 'react';

import { onDark } from '../consentSurface';

/**
 * Two arrows, one each way — the connector from the reference screens. Half-heads only, on the
 * leading end, as in the Datadog reference.
 *
 * Drawn wide and flat on its own 22×12 grid — inking 19 × 11 at a 2px stroke — rather than inside
 * a square. A connector near square reads as a third mark in the row; a long, low one reads as the
 * space between the two real ones. That shape is also what lets it take the horizontal room it
 * needs to be seen without gaining any weight, so the stroke can stay finer than the marks' own.
 *
 * At the marks' brightness rather than dimmed: a connector this fine disappears if it is also dim.
 */
export const ExchangeArrows: React.FC = () => (
  <Box
    component="svg"
    viewBox="0 0 22 12"
    aria-hidden
    sx={{ ...onDark.secondaryText, width: 22, height: 12, flexShrink: 0 }}
  >
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M2.5 4h17M17 1.5 19.5 4" />
      <path d="M19.5 8h-17M5 10.5 2.5 8" />
    </g>
  </Box>
);

export default ExchangeArrows;
